import React from 'react'
import styled from 'styled-components'
import EducationItem from './EducationItem'
import {AiFillCar} from 'react-icons/ai'
import {FaGraduationCap} from 'react-icons/fa'

export default function Education() {
    const educationList = [
        {
            degree: "10TH",
            institution: "L.K. International School",
            duration: "June 2013 - May 2014",
            img:"https://cdn.slidesharecdn.com/ss_thumbnails/a1db8e6d-bb50-4b18-a270-0604498ddeab-160414042508-thumbnail-4.jpg?cb=1460608259"
        },
        {
            degree: "12TH",
            institution: "L.K. International School",
            duration: "June 2015 - May 2016",
            img:"https://cdn.slidesharecdn.com/ss_thumbnails/eca44c41-7836-4c28-b41f-b0f1c7e263dc-150525020403-lva1-app6891-thumbnail-4.jpg?cb=1432519463"
        },
        {
            degree: "B.Com",
            institution: "University of Delhi",
            duration: "June 2016 - May 2019",
            img:"https://www.consumercomplaints.in/thumb.php?complaints=2181146&src=630466939.jpg&wmax=900&hmax=900&quality=85&nocrop=1"
        },
        {
            degree: "PGDCA",
            institution: "IGNOU",
            duration: "June 2019 - May 2020",
            img:"https://qph.fs.quoracdn.net/main-qimg-82fce73a51a13f901e84d93c983f2d58"
        },
        {
            degree: "MCA",
            institution: "IGNOU",
            duration: "June 2019 - May 2022",
            img:"https://qph.fs.quoracdn.net/main-qimg-82fce73a51a13f901e84d93c983f2d58"
        }
    ]
    return (
        <Wrapper id="education">
            <h3 className="section-heading">
                <span><FaGraduationCap /></span>
                <span>Education</span>
            </h3>
            <div className="timeline">
                {
                    educationList.map((elem,index) => {
                        return <EducationItem key={index} data={elem} />
                    })
                }
                <div className="timeline-divider">
                    <div className="timeline-traveller"><AiFillCar /></div>
                </div>
            </div>
        </Wrapper>
    )
}

const Wrapper = styled.div`
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
margin: 40px auto;


.section-heading {
    width: auto;
    padding: 20px 10px 10px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
}

.section-heading span {
    font-size: 40px;
    color: var(--section-color);
    padding-top: 10px;
    display: flex;
    align-items: center;
    margin-right: .5rem;
}

.timeline {
    position: relative;
    width: 80%;
    margin: 5rem auto;
}

.timeline-box {
    position: relative;
    width: 40%;
    left: 5%;
    padding: .5rem 1rem;
    border-radius: 1rem;
    transition: all .3s ease-in-out;
    background-color: #1d1c21;
    cursor: default;
    &:hover {
        box-shadow: 0px 0px 5px 2px var(--section-color);
        background-color: transparent;
    }
    &:nth-child(even) {
        left: 53%;
    }
    &:nth-child(odd):after {
        content: "";
        position: absolute;
        top: 32%;
        right: -8.7%;
        border-radius: 50%;
        width: 1rem;
        height: 1rem;
        background-color: lightgrey;
        z-index: 1;
    }
    &:nth-child(even)::before {
        content: "";
        position: absolute;
        top: 32%;
        left: -8.4%;
        border-radius: 50%;
        width: 1rem;
        height: 1rem;
        background-color: lightgrey;
        z-index: 1;
    }
}


    
.timeline-divider {
    position: absolute;
    height: 90%;
    width: 0;
    border: 3px dashed #0096fa6b;
    top: 8%;
    left: 50%;
}



.timeline-traveller {
    position: sticky;
    top: 30%;
    color: var(--section-color);
    transform: rotate(90deg);
    z-index: 2;
}

.timeline-traveller svg {
    font-size: 2rem;
}

.timeline-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.timeline-details {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    h3 {
        color: var(--section-color);
    }
    h4 {
        color: #df7843;
    }
    p {
        color: grey;
    }
}

.timeline-img {
    width: 50px;
    height: 50px;
}

.timeline-img>img {
    width: 100%;
    height: 100%;
    border-radius: 20px;
}

.color-white {
    color: white !important;
}
`